<script>
	// Logic
	import { onMount } from "svelte";
	// import { worldData } from "../utils/apiStore";

	// Components
	import NorAndWorld from "../components/NorAndWorld.svelte";
	import Rogaland from "../components/Rogaland.svelte";
	import Articles from "../components/Articles.svelte";
	import VaksineTable from "../components/VaksineTable.svelte";
	import KommuneList from "../components/KommuneList.svelte";
	// Bindings
	let world = {};

	onMount(() => {
		window.scrollTo(0, 0);
		// worldData.subscribe((value) => {
		// 	if (value != undefined) {
		// 		world = value;
		// 	}
		// });
	});
</script>

<div class="page-content-section">
	<div class="page-content wide mt-6">
		<Rogaland title="Rogaland" />
	</div>
	<div class="page-content mt-4">
		<div class="sa-source mt-4">
			<span class="sa-source__bold">Kilde:</span>
			<a
				class="sa-source__link"
				href="https://helse-stavanger.no/koronavirus/for-media#oversikt-over-innlagte-pasienter"
				>SUS</a
			>
			og
			<a class="sa-source__link" href="https://www.fhi.no/"
				>Smittetall for Rogaland henter vi automatisk fra Meldingssystem for
				smittsomme sykdommer (MSIS). Disse dataene oppdateres to ganger i
				døgnet.</a
			>
		</div>
	</div>
	<!-- <div class="page-content mt-4"> -->
	<!-- </div> -->
	<!-- <div class="page-content">
        <h1 class="page-content__title">Helseforetak</h1>
        <p class="page-content__ingress">Tabellen viser tall hentet automatisk fra helseforetakene, feil kan derfor forekomme.</p>
        <HelseforetakNew/>
    </div> -->
	<!-- <div class="page-content">
		{#if world.data != undefined}
			<NorAndWorld worldData={world} />
		{/if}
	</div> -->

	<div class="page-content">
		<h1 class="page-content__title">Vaksineoversikt</h1>
		<p class="page-content__ingress">Antall doser satt i Rogaland.</p>
		<VaksineTable />
	</div>

	<div class="page-content">
		<h1 class="page-content__title">Kommuneoversikt</h1>
		<p class="page-content__ingress">Velg kommune for å se hele utviklingen.</p>
		<!-- <KommuneTable/> -->
		<KommuneList />
	</div>

	<div class="page-content" id="articles">
		<h1 class="page-content__title">Siste saker</h1>
		<p class="page-content__ingress">Våre siste artikler om koronaviruset.</p>
		<Articles />
	</div>
</div>

<style lang="scss">
</style>
